import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import UserProfile from './components/UserProfile';
import CreateProfile from './components/CreateProfile';
import EditProfile from './components/EditProfile';
import EditUserAccount from './components/EditUserAccount';
import Login from './components/Login';
import Register from './components/Register';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('token');
    const userData = localStorage.getItem('user');
    
    if (token && userData) {
      try {
        const parsedUser = JSON.parse(userData);
        setIsAuthenticated(true);
        setUser(parsedUser);
        console.log('User loaded from localStorage:', parsedUser);
      } catch (error) {
        console.error('Error parsing user data:', error);
        // Clear invalid data
        localStorage.removeItem('token');
        localStorage.removeItem('user');
      }
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setIsAuthenticated(false);
    setUser(null);
  };

  return (
    <Router>
      <div className="App">
        <div className="container">
          <Routes>
            <Route path="/" element={<LandingPage />} />
            {/* Login and Register routes are always available */}
            <Route path="/login" element={<Login onLogin={setIsAuthenticated} setUser={setUser} />} />
            <Route path="/register" element={<Register onLogin={setIsAuthenticated} setUser={setUser} />} />
            {/* Protected routes - only accessible when authenticated */}
            {isAuthenticated && (
              <>
                <Route path="/dashboard" element={<UserProfile user={user} onLogout={handleLogout} />} />
                <Route path="/create" element={<CreateProfile />} />
                <Route path="/edit-account" element={<EditUserAccount />} />
                <Route path="/edit/:id" element={<EditProfile />} />
              </>
            )}
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
